export const experiences = [
  {
    company: "PSC Computer Center CO., LTD",
    url: "https://www.psccomputer.com.kh/",
    logo: "https://psccomputer.com.kh/logo/psc_new_logo.png", // replace with actual logo
    roles: [
      {
        title: "Junior Web Developer",
        period: "May 2025 - Present",
        skills: [
          {
            name: "Laravel",
            icon: "https://cdn.simpleicons.org/laravel/FF2D20",
          },
          { name: "PHP", icon: "https://cdn.simpleicons.org/php/777BB4" },
          {
            name: "Tailwind CSS",
            icon: "https://cdn.simpleicons.org/tailwindcss/06B6D4",
          },
          { name: "HTML", icon: "https://cdn.simpleicons.org/html5/E34F26" },
          { name: "CSS", icon: "https://cdn.simpleicons.org/css/1572B6" },
          {
            name: "Bootstrap",
            icon: "https://cdn.simpleicons.org/bootstrap/7952B3",
          },
          { name: "MySQL", icon: "https://cdn.simpleicons.org/mysql/4479A1" },
          { name: "jQuery", icon: "https://cdn.simpleicons.org/jquery/0769AD" },
          { name: "Figma", icon: "https://cdn.simpleicons.org/figma/F24E1E" },
          //   {
          //     name: "Laravel",
          //     icon: "https://cdn.simpleicons.org/laravel/FF2D20",
          //   },
          //   { name: "React", icon: "https://cdn.simpleicons.org/react/61DAFB" },
          //   {
          //     name: "Next.js",
          //     icon: "https://cdn.simpleicons.org/nextdotjs/ffffff",
          //   },
          //   {
          //     name: "TypeScript",
          //     icon: "https://cdn.simpleicons.org/typescript/3178C6",
          //   },
          //   {
          //     name: "Node.js",
          //     icon: "https://cdn.simpleicons.org/nodedotjs/339933",
          //   },
          //   {
          //     name: "Express.js",
          //     icon: "https://cdn.simpleicons.org/express/ffffff",
          //   },
          //   {
          //     name: "PostgreSQL",
          //     icon: "https://cdn.simpleicons.org/postgresql/4169E1",
          //   },

          {
            name: "Google Analytics",
            icon: "https://img.icons8.com/color/48/google-analytics.png",
          },
        ],
      },
      //   {
      //     title: "Junior Frontend Developer",
      //     period: "Oct 2020 - Oct 2022",
      //     skills: [
      //       {
      //         name: "JavaScript",
      //         icon: "https://cdn.simpleicons.org/javascript/F7DF1E",
      //       },
      //       { name: "jQuery", icon: "https://cdn.simpleicons.org/jquery/0769AD" },
      //       { name: "HTML", icon: "https://cdn.simpleicons.org/html5/E34F26" },
      //       { name: "CSS", icon: "https://cdn.simpleicons.org/css/1572B6" }, // css3 → css
      //       { name: "Sass", icon: "https://cdn.simpleicons.org/sass/CC6699" },
      //       {
      //         name: "Tailwind CSS",
      //         icon: "https://cdn.simpleicons.org/tailwindcss/06B6D4",
      //       },
      //       {
      //         name: "Bootstrap",
      //         icon: "https://cdn.simpleicons.org/bootstrap/7952B3",
      //       },
      //       { name: "PHP", icon: "https://cdn.simpleicons.org/php/777BB4" },
      //       { name: "MySQL", icon: "https://cdn.simpleicons.org/mysql/4479A1" },
      //       {
      //         name: "Laravel",
      //         icon: "https://cdn.simpleicons.org/laravel/FF2D20",
      //       },
      //     ],
      //   },
      {
        title: "UI/UX Designer",
        period: "May 2025 - Present",
        skills: [
          //   {
          //     name: "Ms.Word",
          //     icon: "https://img.icons8.com/color/48/microsoft-word-2019--v1.png",
          //   },
          //   {
          //     name: "Ms.Excel",
          //     icon: "https://img.icons8.com/color/48/microsoft-excel-2019--v1.png",
          //   },
          //   {
          //     name: "Ms.PowerPoint",
          //     icon: "https://img.icons8.com/color/48/microsoft-powerpoint-2019--v1.png",
          //   },
          {
            name: "Figma",
            icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/figma/figma-original.svg",
          },
          {
            name: "Illustrator",
            icon: "https://img.icons8.com/color/48/adobe-illustrator.png",
          },
          {
            name: "Photoshop",
            icon: "https://img.icons8.com/color/48/adobe-photoshop.png",
          },
          { name: "HTML", icon: "https://cdn.simpleicons.org/html5/E34F26" },
          { name: "CSS", icon: "https://cdn.simpleicons.org/css/1572B6" },
          //   {
          //     name: "Adobe XD",
          //     icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/xd/xd-plain.svg",
          //   },
        ],
      },
    ],
  },
  {
    company: "Matic Cup",
    url: "https://manticcup.vercel.app/",
    logo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRp1qh4DJcuKKsq6e8iO6uoL8ToXrdEDcXx8g&s", // replace with actual logo
    roles: [
      {
        title: "Junior Web Developer",
        period: "May 2025 - Present",
        skills: [
          { name: "React", icon: "https://cdn.simpleicons.org/react/61DAFB" },
          { name: "HTML", icon: "https://cdn.simpleicons.org/html5/E34F26" },
          { name: "CSS", icon: "https://cdn.simpleicons.org/css/1572B6" },
          { name: "MySQL", icon: "https://cdn.simpleicons.org/mysql/4479A1" },
          { name: "Figma", icon: "https://cdn.simpleicons.org/figma/F24E1E" },
          {
            name: "Bootstrap",
            icon: "https://cdn.simpleicons.org/bootstrap/7952B3",
          },
          {
            name: "Google Analytics",
            icon: "https://img.icons8.com/color/48/google-analytics.png",
          },
        ],
      },
    ],
  },
  {
    company: "Kilo IT",
    url: "https://kh.linkedin.com/company/kiloit-org",
    logo: "https://media.licdn.com/dms/image/v2/D4D0BAQHXq-f0oXGuyQ/company-logo_200_200/company-logo_200_200/0/1697014805803/kiloit68_logo?e=2147483647&v=beta&t=SKyEoiFbwhE1-zwRHyv3bX984NwsV2F2-qj0nuCxPgA", // replace with actual logo
    roles: [
      {
        title: "Internship Front-End Developer",
        period: "Jul 2024 - Dec 2025",
        skills: [
          { name: "React", icon: "https://cdn.simpleicons.org/react/61DAFB" },
          {
            name: "Node.js",
            icon: "https://cdn.simpleicons.org/nodedotjs/339933",
          },
          { name: "HTML", icon: "https://cdn.simpleicons.org/html5/E34F26" },
          { name: "CSS", icon: "https://cdn.simpleicons.org/css/1572B6" },
          { name: "MySQL", icon: "https://cdn.simpleicons.org/mysql/4479A1" },
          { name: "Figma", icon: "https://cdn.simpleicons.org/figma/F24E1E" },
        ],
      },
    ],
  },
];
